import {
  error_reason_no_role,
  error_reason_ip_blocked,
  error_reason_invalid_role,
  success_reason_social_login,
  error_reason_account_blocked,
  error_reason_account_inactive,
  error_reason_social_auth_failed,
  error_reason_social_email_not_found,
} from "../../../utils/GlobalConstants";
import Toaster from "../../Toast/Toast";
import { routes } from "../../../routes";
import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import DashBoardFooter from "../footer/Footer";
import DashBoardHeader from "../header/Header";
import LiveDrop from "../../livedrop/LiveDrop";
import { useEffect, useRef, useState } from "react";
import { icons } from "../../../utils/globalImages";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import IpRestrictionsCheck from "./IpRestrictionsCheck";
import PrivacyBanner from "../../PrivacyBanner/PrivacyBanner";
import { pushUserId } from "../../../utils/GoogleTagTracking";
import PromotionModal from "../../PromotionModal/PromotionModal";
import { SOCIAL_TOAST_KEY } from "../../../utils/GlobalConstants";
import { syncUserData } from "../../../services/userSync.service";
import { toggleOnboard } from "../../../redux/slices/onBoardingSlice";
import useUserSession from "../../../customHooks/User/useUserSession";
import { userSocialToken } from "../../../api/modules/b2droppie.class";
import OfflineNotice from "../../../pages/OfflineNotice/OfflineNotice";
import ScrollToTop from "../../../customHooks/ScrollToTop/ScrollToTop";
import idleSessionService from "../../../services/idleSession.service";
import { getCookie, setCookie } from "../../../services/cookies.service";
import { clearAuth, updateUserData } from "../../../redux/slices/authSlice";
import useWindowDimensions from "../../../customHooks/useDimension/useDimension";

const Layout = ({ type = "plain" }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const elementRef = useRef(null);
  const { width } = useWindowDimensions();
  const cameFromProtected = !!location.state?.from;
  const [ipCheckData, setIpCheckData] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const { user, loading, setLoading, toast, isLoggedIn } = useUserSession();
  const shouldHide =
    location.pathname.startsWith("/unboxing/box/spin") ||
    location.pathname.startsWith("/reset-password") ||
    location.pathname.startsWith("/myaccount") ||
    location.pathname.startsWith("/battles") ||
    location.pathname.startsWith("/battles/create/battle") ||
    location.pathname.startsWith("/blog") ||
    location.pathname.startsWith("/battle/play");

  const socialCode = searchParams.get("code");
  const isSocialLogin = location.pathname === "/social/callback" && socialCode;

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (cameFromProtected && !isLoggedIn) {
      dispatch(toggleOnboard({ login: true }));
    }
  }, [cameFromProtected, isLoggedIn, dispatch]);

  useEffect(() => {
    if (user && user.id) {
      pushUserId(user.id);
    } else {
      pushUserId(undefined);
    }
  }, [user]);

  useEffect(() => {
    if (
      ipCheckData &&
      ipCheckData.status === 403 &&
      ipCheckData.success === false
    ) {
      navigate("/access-restricted", { replace: true });
    }
    if (
      ipCheckData &&
      ipCheckData.status === 200 &&
      ipCheckData.success === true &&
      location.pathname === "/access-restricted"
    ) {
      navigate("/", { replace: true });
    }
  }, [ipCheckData, navigate]);

  const updateUserSocialToken = async (token) => {
    setLoading(true);
    try {
      const data = await userSocialToken({ code: token });
      if (data) {
        const user = await syncUserData();
        if (user) dispatch(updateUserData(user));
      }
    } catch (err) {
      console.error("Failed to fetch user data:", err);
    } finally {
      setLoading(false);
    }
  };

  // === Common sections ===
  const Header = <DashBoardHeader loading={loading} setLoading={setLoading} />;
  const Footer = <DashBoardFooter />;

  // === Plain layout ===
  if (type === "plain") {
    return (
      <>
        {Header}
        <Outlet />
        {Footer}
        <PrivacyBanner />
      </>
    );
  }

  // === Sidebar layout ===
  return (
    <>
      <IpRestrictionsCheck
        setLoading={setLoading}
        ipCheckData={ipCheckData}
        setIpCheckData={setIpCheckData}
      />
      <Toaster message={toast} />
      <ScrollToTop />
      {!cameFromProtected && <PromotionModal />}
      {Header}
      {/* {!shouldHide && isOnline && <LiveDrop screen="mobile" />} */}
      {isOnline ? (
        <section className="mainBody">
          <Row className="m-0 LayoutMain">
            {width >= 770 ? (
              <Col ref={elementRef} className="p-0 mainbody-section1">
                <Outlet />
              </Col>
            ) : (
              <Outlet />
            )}
          </Row>

          {/* Free Box Icon */}
          {user?.free_boxes && (
            <button
              onClick={() =>
                navigate(`${routes.ACCOUNT}/${routes.ACCOUNT_FREEBOXES}`)
              }
              className="free-box-badge-outer rounded-circle"
            >
              <img
                height={80}
                alt="Free Box"
                src={icons.freeBox}
                className="free-box"
              />
              {user?.free_boxes_remaining > 0 && (
                <span className="free-box-badge">
                  {user?.free_boxes_remaining > 99 ? (
                    <span>
                      99<small>+</small>
                    </span>
                  ) : (
                    user?.free_boxes_remaining
                  )}
                </span>
              )}
            </button>
          )}
          {Footer}
        </section>
      ) : (
        <OfflineNotice online={isOnline} isDark={isDarkMode} />
      )}
      <PrivacyBanner />
    </>
  );
};

export default Layout;
